// extracted by mini-css-extract-plugin
module.exports = {"component":"_23WL1","button":"_1PXsl","unreadMessages":"_2r_kU","buttonIcon":"_2yYfO","message":"_1u3q9","messageCloseIcon":"_2lYrA"};